import React from "react";
import { Label } from "@/components/ui/label";

export const Field = ({ label, required, children, className = "" }) => (
  <div className={`space-y-2 ${className}`}>
    <Label className="text-xs uppercase tracking-[0.18em] text-[var(--gg-text-muted)] font-semibold">
      {label} {required && <span className="text-[var(--gg-primary)]">*</span>}
    </Label>
    {children}
  </div>
);
